import {
  ArrowDownTrayIcon,
  EyeIcon,
  MagnifyingGlassIcon,
  PencilIcon,
  PlusIcon,
  ShieldCheckIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../common/DataTable";


export const AssetsTab = ({
  searchTerm,
  setSearchTerm,
  filterCategory,
  setFilterCategory,
  filterCriticality,
  setFilterCriticality,
  filterStatus,
  setFilterStatus,
  setShowAssetModal,
  handleExportAssets,
  loading,
  assets,
  getTypeIcon,
  getCriticalityColor,
  getStatusColor,
  viewAssetDetails,
  setAssetFormData,
  // setSelectedAsset,
  user,
  handleDeleteAsset,
  pagination,
  setPagination,
  assetCategories,
  categories,
  loadAssets,
  assetsPagination,
  setAssetsPagination,
  handleAssetsPageChange,
  activeTab,
  setActiveTab,
}) => {


  const [expandedRowId, setExpandedRowId] = useState(null);
  const [expandedType, setExpandedType] = useState(null);
  const navigate = useNavigate();
  const isCustomerAdmin = user.role === "customer_admin";
  let customerId;
  if (isCustomerAdmin) {
    customerId = user?.id;
  }

  const columns = [
    {
      id: "asset",
      accessorFn: (asset) => asset.connector?.name,
      header: "Asset",
      enableSorting: false,
      meta: { filter: { variant: "text", label: "Asset", placeholder: "Search asset name" } },
      cell: ({ row }) => (
        <div className="text-sm font-medium text-gray-900">{row.original.connector?.name}</div>
      ),
    },
    {
      id: "category",
      accessorFn: (asset) => asset.connector?.type,
      header: "Type & Category",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Category",
          placeholder: "All categories",
          options: categories.map((c) => ({ value: c.id, label: c.name })),
        },
      },
      cell: ({ row }) => (
        <div>
          <div className="text-sm text-gray-900 text-left">{row.original.connector?.type}</div>
          <div className="text-sm text-gray-500 text-left">{row.original.connector?.category}</div>
        </div>
      ),
    },
    {
      id: "owner",
      accessorFn: (asset) => asset.owner?.name,
      header: "Owner",
      enableSorting: false,
      cell: ({ row }) => (
        <span className="text-sm text-gray-900">{row.original.owner?.name}</span>
      ),
    },
    {
      id: "criticality",
      accessorFn: (asset) => asset.criticality,
      header: "Criticality",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Criticality",
          placeholder: "All criticality",
          options: [
            { value: "HIGH", label: "High" },
            { value: "MEDIUM", label: "Medium" },
            { value: "LOW", label: "Low" },
          ],
        },
      },
      cell: ({ row }) => (
        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full border ${getCriticalityColor(row.original.criticality)}`}>
          {row.original.criticality}
        </span>
      ),
    },
    {
      id: "status",
      accessorFn: (asset) => asset.connected,
      header: "Status",
      enableSorting: false,
      meta: {
        filter: {
          variant: "select",
          label: "Status",
          placeholder: "All status",
          options: [
            { value: "true", label: "Connected" },
            { value: "false", label: "Not Connected" },
          ],
        },
      },
      cell: ({ row }) => (
        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(row.original.connected)}`}>
          {row.original.connected ? "Connected" : "Not connected"}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      enableSorting: false,
      cell: ({ row }) => (
        <button
          onClick={() => navigate(`/integrations/${row.original.id}`)}
          disabled={loading}
          className="text-white px-3 py-2 rounded-md flex items-center gap-2 transition-opacity hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: "var(--app-primary-color, #26256b)" }}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="space-y-6">
        {/* Search and Filters */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 relative">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 mb-4">
            {/* <div className="flex-1 max-w-lg">
            <div className="relative">
              <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search assets..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div> */}

            <div className="flex space-x-2 ml-auto">
              <button
                onClick={() => handleExportAssets("csv")}
                className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                <ArrowDownTrayIcon className="w-4 h-4 mr-2" />
                Export CSV
              </button>
              <button
                onClick={() => handleExportAssets("excel")}
                className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                <ArrowDownTrayIcon className="w-4 h-4 mr-2" />
                Export Excel
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center">
            {/* <div className="flex space-x-3">
            <button
              onClick={() => setShowAssetModal(true)}
              className="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-lg text-sm font-medium text-white hover:bg-blue-700"
            >
              <PlusIcon className="w-4 h-4 mr-2" />
              Manual Add Asset
            </button>
          </div> */}
          </div>
        </div>

        {/* Assets Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <DataTable
            columns={columns}
            data={assets}
            getRowId={(asset) => String(asset.id)}
            loading={loading}
            emptyMessage="No assets found"
            manualPagination
            rowCount={assetsPagination?.total || 0}
            pagination={{
              pageIndex: (assetsPagination?.page || 1) - 1,
              pageSize: assetsPagination?.page_size || 10,
            }}
            onPaginationChange={(updater) => {
              const currentPagination = {
                pageIndex: (assetsPagination?.page || 1) - 1,
                pageSize: assetsPagination?.page_size || 10,
              };
              const nextPagination = typeof updater === 'function'
                ? updater(currentPagination)
                : updater;
              handleAssetsPageChange(nextPagination.pageIndex + 1, nextPagination.pageSize);
            }}
            enableColumnVisibility={false}
            enableColumnResizing
            enableColumnFilters
            manualFiltering
            columnFilters={[
              ...(searchTerm ? [{ id: 'asset', value: searchTerm }] : []),
              ...(filterCategory ? [{ id: 'category', value: filterCategory }] : []),
              ...(filterCriticality ? [{ id: 'criticality', value: filterCriticality }] : []),
              ...(filterStatus ? [{ id: 'status', value: filterStatus }] : []),
            ]}
            onColumnFiltersChange={(updater) => {
              const current = [
                ...(searchTerm ? [{ id: 'asset', value: searchTerm }] : []),
                ...(filterCategory ? [{ id: 'category', value: filterCategory }] : []),
                ...(filterCriticality ? [{ id: 'criticality', value: filterCriticality }] : []),
                ...(filterStatus ? [{ id: 'status', value: filterStatus }] : []),
              ];
              const nextFilters = typeof updater === 'function' ? updater(current) : updater;
              const values = Object.fromEntries(nextFilters.map(({ id, value }) => [id, value]));
              setSearchTerm(values.asset || '');
              setFilterCategory(values.category || '');
              setFilterCriticality(values.criticality || '');
              setFilterStatus(values.status || '');
              setAssetsPagination((prev) => ({ ...prev, page: 1 }));
            }}
            maxBodyHeight="65vh"
          />
        </div>
      </div>
    </>
  );
};
